import React, { useState, useEffect, useCallback } from "react";
import {
  View,
  StyleSheet,
  KeyboardAvoidingView,
  Platform,
  Keyboard,
  TextInput,
  ScrollView,
  FlatList,
  TouchableOpacity,
  Image,
} from "react-native";
import { useFocusEffect } from '@react-navigation/native';
//import { Image } from "react-native-expo-image-cache";
import { MaterialCommunityIcons, 
         AntDesign, 
         Fontisto, 
         Octicons, 
         FontAwesome5, 
         Entypo  } from "@expo/vector-icons";
import * as ImagePicker from "expo-image-picker"
import * as ImageManipulator from "expo-image-manipulator";
import * as DocumentPicker from 'expo-document-picker'


import colors from "../config/colors";
//import ContactSellerForm from "../components/ContactSellerForm";
//import ListItem from "../components/lists/ListItem";
import Text from "../components/Text";
//import { TouchableWithoutFeedback } from "react-native-gesture-handler";
import dateNow from "../utility/dateNow";
//import useAuth from "../auth/useAuth";
import routes from "../navigation/routes";
import connectionConfig from "../config/settings";
import configurationPost from "../config/configurationPost";
import CardSeed from "../components/CardSeed";
import defaultStyles from "../config/styles";
import { Video, AVPlaybackStatus } from 'expo-av';
import AuthContext from "../auth/context";
 

import VideoVisor from "../components/VideoVisor";
import ActivityIndicator from "../components/ActivityIndicator";
import PickerActionsScreen from "./PickerActionsScreen";
import createNotification from "../utility/createNotification";

const webUrl = connectionConfig.imageUrl + '/seedImages/'

var pointer = 0
var blockSize = 30
var pageNumber = 0
var arrayActions = []
var date = dateNow()
let newSeedId = 0
var indexLike = 0
var pickSeedId = 0
var changeListing = true
var type = 0
var typeFileImageAndVideo = ''
var nameDateImageAndVideo = ''
var typeFile = ''
var nameDateDoc = ''
var seedId = 0
var prueba19julCount = 0

//var listing = []
//let newSeedPath = []

function ActionScreen({ navigation, route, props  }) {
  //debugger
  //const [newSeedId, setNewSeedId] = useState(0);
  const [newPath, setNewPath] = useState(0);
  const [showActions, setShowActions] = useState("Show Actions");
  //const [count, setCount] = useState(0)
  const { user, setUser } = useContext(AuthContext);
  //const { user } = useAuth()
  
  //const [listing, setListing] = useState([])
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [listing, setListing] = useState([]);

  const [ titleBoxText, setTitleBoxText ] =  useState('') // para que jale el comentario
  const [ descriptionBoxText, setDescriptionBoxText ] =  useState('') // para que jale el comentario 
  const [imageUri, setImageUri] = useState('');
  const [pickerFile, setPickerFile] = useState(null);
  const [videoNumber, setVideoNumber] = useState(''); // Link de video de youtube 
  const [youtubeLink, setYoutubeLink] = useState(''); // Id de video de youtube extraído del link mediante método onChangeText

 
  const video = React.useRef(null);


  const HEIGHT = 315.2727355957031
  //(Dimensions.get('window').height) * .5;
  
  const sizeItemLayout = ( item, index) => (
    {length: HEIGHT, offset: HEIGHT * index, index}
  );

  // function actualizaNewSeed () {
  //   pathSeed()
  //   console.log("actualiza newSeed")
  //   console.log(count) 
  //   setCount(count+1)
  // }

  useEffect(() => {
    //debugger
      date = dateNow()
      setListing(route.params); 
      console.log(listing + "Listing ANTES de post GenerateActionId")
  }, []);



//   useFocusEffect(
//     useCallback(() => {
//       date = dateNow() 
//       pruebaFocusCallBack() 
//       //setListing(route.params); 
//        }, [prueba19julCount]) //seedId
//   );

//   const pruebaFocusCallBack = async () => {
//    if(changeListing === true){
//     setListing(route.params); 
//     console.log('Esto arroja si changeListing es true: '  + listing )
//    } else {
//     setListing(arrayActions) 
//     console.log('Esto arroja si changeListing es false: '  + listing )
//    }
//  }

   
   //--------------------------------------------
  // Tipos de acción: semilla = 0
  //                  info    = 1
  //                  idea    = 2
  //                  plan    = 3
  //                  acción  = 4
  //                  atraer  = 5
  //                  jugar   = 6
  //                  rama    = 7
  //                  publicar= 8
  //                  donar   = 9
  //---------------------------------------------



//---------------------------------------------
// Función para traer el seedId
//---------------------------------------------
const generateActionId = async () => {
   setLoading(true)
   console.log("función generateActionId ==> ", videoNumber)
  //setProgress(0.3);
    //Valida el tipo de archivo que se eligio 
    if (pickerFile != null) {
      if (pickerFile.name.includes('.pdf')) {
        typeFile = 'application/pdf'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.pdf'
      }
      if (pickerFile.name.includes('.avi')) {
        typeFile = 'video/x-msvideo'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.avi'
      }
      if (pickerFile.name.includes('.mp4')) {
        typeFile = 'application/mp4'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.mp4'
      }
      if (pickerFile.name.includes('.mov')) {
        typeFile = 'video/quicktime'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.mov'
      }
      if (pickerFile.name.includes('.jpg')) {
        typeFile = 'image/jpeg'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.jpg'
      }
      if (pickerFile.name.includes('.png')) {
        typeFile = 'image/png'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.png'
      }
      if (pickerFile.name.includes('.xls')) {
        typeFile = 'application/vnd.ms-excel'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.xls'
      }
      if (pickerFile.name.includes('.xlsx')) {
        typeFile = 'application/xlsx'
        nameDateDoc = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.xlsx'
      } 
    }
    //Valida si es imagen o video lo que se eligio
    if (imageUri != '') {
      if (imageUri.includes('.jpg')) {
        typeFileImageAndVideo = 'image/jpeg'
        nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.jpg'
      }
      if (imageUri.includes('.png')) {
        typeFileImageAndVideo = 'image/png'
        nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.png'
      }
      if (imageUri.includes('.mp4')) {
        typeFileImageAndVideo = 'application/mp4'
        nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.mp4'
      }
      if (imageUri.includes('.mov')) {
        typeFileImageAndVideo = 'video/quicktime'
        nameDateImageAndVideo = JSON.parse(user).userId + '_' + date.replace(/ /g, '_').replace(/\//g, '-') + '_GenerateSeed.mov'
      }
    }
  var post_values = {
      userId           : JSON.parse(user).userId,
      createDateSeed   : date,
      type             : listing.type,
      origin           : listing.seedId,
      seedName         : titleBoxText,
      seedDescription  : descriptionBoxText,
      seedPhoto        : nameDateImageAndVideo,
      documentSeed     : nameDateDoc,
      youtubeId        : videoNumber

    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl+'/insertAction/', configurationPost)
    .then(response => response.json())
    .then(response => {
      console.log( {response} + "Listing despues de post GenerateActionId")
      newSeedId = response.data.insertId
      seedId = newSeedId
      prueba19julCount = prueba19julCount + 1
      var  descripNotification = JSON.parse(user).userName + ' agregó una nueva acción a tu semilla'  
      var  seedId = listing.seedId
      var  userId = JSON.parse(user).userId 
      var  notificationTypeId = 2
      var  CompOrigin = 'AddSeed'
        createNotification.insertNotification(descripNotification,seedId, userId, notificationTypeId, CompOrigin)

      if (imageUri != '') {
        savePhoto()
      }
      if (pickerFile != null) {
        saveMultiple()
      }
      
      setTimeout(function(){ selectAddedAction(); }, 500); 
      
      
      //selectAddedAction()    10 de agosto 2021
      //navigation.navigate(routes.SEED_DETAILS, seedId) 
      //setProgress(0.7);
      //setUploadVisible(true)
    })
    .catch(err =>{
      console.log('update fixo failed :( review internet service /insertAction/', err )
    })

};


//------------------------------------------------------------
//  Función encadenada para traer la info de la nueva acción. 
//------------------------------------------------------------

const selectAddedAction = async () => {
  var post_values = {
    //seedId: seedId
    seedId: newSeedId
   }
  configurationPost.body = JSON.stringify(post_values)
  await fetch(connectionConfig.apiUrl+'/selectActionFromFlatlist/', configurationPost)
  .then(response => response.json())
  .then(response => {
   //debugger
   //var item = []
   var item = response     //response.data
   setLoading(false)
   //setListing(response.data)
   changeListing = true
   var screen = 'ActionScreen'
   navigation.navigate(routes.SEED_DETAILS, { item, screen, changeListing } ) 
  })
  .catch(err =>{
  console.log(':( review internet service /selectActionFromFlatlist/', err )
  })

}


//--------------------------------------------------
//  Select si se hace path para semilla 
//  u otra acción.
//--------------------------------------------------
const pathSelect = async () => {
console.log("Type es "+ listing.type + "Path es: " + listing.path)
  if(listing.type===0){
  pathSeed()
} else {
  pathAction()
}
}



//---------------------------------------------
// Función para generar Path de una semilla
//---------------------------------------------
const pathSeed = async () => {
  //debugger
  console.log("ya entre a pathseed")
  //console.log(pathSeed)

  var pathSeed = listing.seedId +"/"+ newSeedId
  setNewPath(pathSeed)
  console.log(pathSeed)
  console.log("ya voy a mandar el pathseed")


  //console.log(newSeedId)

  var post_values = {
      path             : pathSeed,
      seedId           : newSeedId
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl+'/updatePathSeed/', configurationPost)
    .then(response => response.json())
    .then(response => {
      setNewPath(pathSeed)
      //setProgress(0.7);
      //setUploadVisible(true)
      if (type != 0) {
          //pathSeed()
        //console.log(newPath)
      }
    })
    .catch(err =>{
      console.log('update fixo failed :( review internet service /updatePathSeed/', err )
    })

};

//-------------------------------------------------------
// Función para generar path de cualquier otra acción.
//-------------------------------------------------------
const pathAction = async () => {
  //debugger
  console.log("ya entre a pathAction")
  //console.log(pathSeed)

  var pathSeed = listing.path +"/"+ newSeedId
  setNewPath(pathSeed)
  console.log(pathSeed)
  console.log("ya voy a mandar el pathAction")

  var post_values = {
      path             : pathSeed,
      seedId           : newSeedId
    }
    configurationPost.body = JSON.stringify(post_values)
    await fetch(connectionConfig.apiUrl+'/updatePathSeed/', configurationPost)
    .then(response => response.json())
    .then(response => {
      setNewPath(pathSeed)
      //setProgress(0.7);
      //setUploadVisible(true)
      if (listing.type != 0) {
          //pathSeed()
        //console.log(newPath)
      }
    })
    .catch(err =>{
      console.log('update fixo failed :( review internet service /updatePathSeed/', err )
    })

};

//--------------------------------------------- 
//Rutina para guardar una foto o video
//---------------------------------------------
const savePhoto = async () => {
  let format = 'JPEG'
  let quality = 0.1
 debugger
  try {
    const formData = new FormData()
    if (typeFileImageAndVideo === 'image/jpeg' ) {
      const manipResult = await ImageManipulator.manipulateAsync( 
        imageUri,
        [],
        { compress: quality, format: ImageManipulator.SaveFormat.JPEG })
      formData.append('photoAndVideo', {
        uri: manipResult.uri,
        type: typeFileImageAndVideo,
        name: nameDateImageAndVideo,
      })
    }
    if (typeFileImageAndVideo === 'image/png') {
      const manipResult = await ImageManipulator.manipulateAsync( 
        imageUri,
        [],
        { compress: quality, format: ImageManipulator.SaveFormat.JPEG })
      formData.append('photoAndVideo', {
        uri: manipResult.uri,
        type: typeFileImageAndVideo,
        name: nameDateImageAndVideo,
      })
    }
    if (typeFileImageAndVideo === 'application/mp4') {
      formData.append('photoAndVideo', {
        uri: imageUri,
        type: typeFileImageAndVideo,
        name: nameDateImageAndVideo,
      })
    }
    if (typeFileImageAndVideo === 'video/quicktime') {
      formData.append('photoAndVideo', {
        uri: imageUri,
        type: typeFileImageAndVideo,
        name: nameDateImageAndVideo,
      })
    }
    const configurationPost = {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'multipart/form-data'
      },
      body: formData
    }
    // post Para guardar imagen de perfil
    fetch(connectionConfig.apiUrl + '/upload_infoPhotoAndVideo', configurationPost)
      .then(response => response.json())
      .then(response => {
        //debugger
        //setProgress(0.8)
        nameDateImageAndVideo = ''
        setImageUri('')
        //pathSelect()

        if (response.data === 'descarga-> error') {
          console.log("maintennance server descarga-> error /upload_infoPhotoAndVideo")
        }
      })
      .catch((err) => {
        console.log("maintennance server -> catch /upload_infoPhotoAndVideo", err)
      })
  } catch (error) {
    console.log("maintennance server -> catch Final /upload_infoPhotoAndVideo", error)
  }
}


 

//--------------------------------------------------
//  Select Image es la función que te permite sacar
//  la biblioteca de imagenes de tu Cel 
//--------------------------------------------------
const selectImage = async () => {
  try {
    const result = await ImagePicker.launchImageLibraryAsync({
      mediaTypes: ImagePicker.MediaTypeOptions.All,
      allowsEditing: true,
      aspect: [4, 3],
      quality: 0,
    })
    console.log("Este es el result de imagen: ", result)
    if(!result.cancelled)
    setImageUri(result.uri)
  } catch (error) {
     console.log("error al leer imagen", error) 
  }
}



//----------------------------------------------------------------------------
// Servicio para buscar un navegador de archivos del celular para buscar un pdf 
//   (Esta función es para seleccionar el documento)
//----------------------------------------------------------------------------
const uploadDocument = async () => {
  var options = {
    type: 'image/png'
  }
  if (Platform.OS === 'android') {
 
    options = {
    
      copyToCacheDirectory: true,
      multiple: false
    }
  } else {
    options = {
      copyToCacheDirectory : true,
     
      multiple: false
    }
  }
  try {
    if (Platform.OS === 'android') {
      await DocumentPicker.getDocumentAsync(options)
      .then(res => {
       // debugger
       if (res.type === 'cancel') {
        setPickerFile(null);
 
       } else {
        setPickerFile(res);
       }
        console.log('res : ' + JSON.stringify(res));
        console.log('User cancelled file picker->', res);
        console.log(res.uri, res.type, res.name, res.size)
 
      })
    } else {
      await DocumentPicker.getDocumentAsync(options)
      .then(res => {
       // debugger
       if (res.type === 'cancel') {
        setPickerFile(null);
 
       } else {
        setPickerFile(res);
       }
        console.log('res : ' + JSON.stringify(res));
        console.log('User cancelled file picker->', res);
        console.log(res.uri, res.type, res.name, res.size)
 
      })
      
    }
    
  } catch (err) {
    setPickerFile(null);
   
      alert('Unknown Error: ' + JSON.stringify(err));
      throw err;
  }
 }
 
 
//---------------------------------------------
//   Rutina que guarda el document de la info 
//  (Esta función es llamada para guardar el 
//     documento seleccionado en una carpeta 
//              en el servidor).
//---------------------------------------------
const saveMultiple = async () => {
  debugger
  try {      
    const formData = new FormData()
    formData.append('multiservice',{
      uri:  pickerFile.uri,
      type: typeFile,
      name: nameDateDoc,
    })
    console.log("typeFile -> ", typeFile,"nameDateDoc ->", nameDateDoc  )
    const configurationPost = {
      method :'POST',
      headers:{
        'Accept': 'application/json',
        'Content-Type':'multipart/form-data'
      },
      body:formData
    }
   // post Para guardar imagen de perfil
    fetch(connectionConfig.apiUrl + '/upload_Documents', configurationPost)
    .then(response => response.json())
    .then(response => {
      //debugger
      setProgress(1)
      setPickerFile(null)
      if(response.data === 'descarga-> error'){
        console.log("maintennance server /upload_Documents descarga-> error")   
      }
    })
    .catch((err) => {
      console.log( "maintennance server -> catch /upload_Documents ", err)   
    })
  } catch (error) {
    console.log( "maintennance server -> catch Final /upload_Documents ", error)   
  }
}
 
//----------------------------------------------------
//   Función para extraer el Id del link de Youtube
//----------------------------------------------------
// "https://www.youtube.com/watch?v=WWzEK7NLi74youTubeUrl"
//  const videoNumber = ("WWzEK7NLi74");
const onChangeText = async () => {
  setYoutubeLink(videoNumber)
 console.log(youtubeLink)
 //setCountPasteYoutube(countPasteYoutube+1)

 // if(countPasteYoutube<=1){
 //   setYoutubeLink(text)
 //   setCountPasteYoutube(countPasteYoutube+1)
 
     try {
       let re = /^(https?:\/\/)?((www\.)?(youtube(-nocookie)?|youtube.googleapis)\.com.*(v\/|v=|vi=|vi\/|e\/|embed\/|user\/.*\/u\/\d+\/)|youtu\.be\/)([_0-9a-z-]+)/i;
       const id = youtubeLink.match(re)[7];
       setVideoNumber(id)
       console.log(id)
       console.log(videoNumber)
       //if(!id === '')
       //setVideoNumber(id)
       //console.log(videoNumber)
     } catch (error) {
       console.log("error en el link de Youtube", error) 
     }
   
} 


  return (
    <>
    <ScrollView>
    <ActivityIndicator visible={loading}/>
    
      <View style={ listing.type === 0 ? styles.seedTitle :
                    listing.type === 1 ? styles.seedTitle1 :
                    listing.type === 2 ? styles.seedTitle2 :
                    listing.type === 3 ? styles.seedTitle3 :
                    listing.type === 4 ? styles.seedTitle4 :
                    listing.type === 5 ? styles.seedTitle5 :
                    listing.type === 6 ? styles.seedTitle6 :
                    listing.type === 7 ? styles.seedTitle7 :
                    listing.type === 8 ? styles.seedTitle8 :
                    styles.seedTitle9
                     }>
                       {
                    listing.type === 0 ?   <Text style={styles.title} >Creating Seed:</Text>:
                    listing.type === 1 ?   <Text style={styles.title} >Creating Information:</Text>:
                    listing.type === 2 ?   <Text style={styles.title} >Idea:</Text>:
                    listing.type === 3 ?   <Text style={styles.title} >Plan:</Text>:
                    listing.type === 4 ?   <Text style={styles.title} >Action:</Text>:
                    listing.type === 5 ?   <Text style={styles.title} >Invite:</Text>:
                    listing.type === 6 ?   <Text style={styles.title} >Ludus:</Text>:
                    listing.type === 7 ?   <Text style={styles.title} >Branch:</Text>:
                    listing.type === 8 ?   <Text style={styles.title} >Publish:</Text>:
                      <Text style={styles.title} >Donate:</Text>
                     }

         {/* <Text style={styles.title} >Type {changeListing ? listing.type :  listing[0].type}</Text>
         <Text style={styles.title} >Seed Id {changeListing ? listing.seedId :  listing[0].seedId}</Text>
         <Text style={styles.title} >Origin {changeListing ? listing.origin :  listing[0].origin}</Text> */}

         <Text style={styles.title} >Type { listing.type }</Text>
         <Text style={styles.title} >Seed Id { listing.seedId }</Text>
         <Text style={styles.title} >Origin { listing.origin }</Text>



        <View style={styles.containerTitleDescription}>                    
                    <TextInput style={styles.input}
                        onChangeText = {text => setTitleBoxText(text)}
                        placeholder = "Title"
                        value = {titleBoxText}
                        />
                        <TextInput style={styles.input}
                        onChangeText = {text => setDescriptionBoxText(text)}
                        placeholder = "Description"
                        value = {descriptionBoxText}
                        />

                      <TouchableOpacity  style={styles.image} onPress = {selectImage}>
                          {/* {imageUri != '' ?  */}
                          {   imageUri.includes(".mov") ?
                              <Video
                              ref={video}
                              style={styles.imagePhoto}
                              source={{
                                uri: imageUri,
                              }}
                              //useNativeControls
                              resizeMode="contain"
                              //isLooping
                              //onPlaybackStatusUpdate={status => setStatus(() => status)}
                            /> :
                              imageUri.includes(".mp4") ?
                              <Video
                              ref={video}
                              style={styles.imagePhoto}
                              source={{
                                uri: imageUri,
                              }}
                              //useNativeControls
                              resizeMode="contain"
                              //isLooping
                              //onPlaybackStatusUpdate={status => setStatus(() => status)}
                            /> :
                            imageUri.includes(".jpg") ?
                         <Image style={styles.imagePhoto} source={{uri: imageUri} } />
                          :
                          imageUri.includes(".png") ?
                          <Image style={styles.imagePhoto} source={{uri: imageUri} } />
                          :
                              <MaterialCommunityIcons 
                              //style={styles.image}
                              name="camera"
                              size={150}
                              color={colors.medium}            
                              />
                          }     
                      </TouchableOpacity>

                      {pickerFile != null ?                         
                        <MaterialCommunityIcons 
                        //style={styles.image}
                        onPress = {()=> uploadDocument()}
                        name={"file-check-outline"}
                        size={35}
                        color={colors.lemonGreen}
                        style={styles.icon}         
                        />

                    :
                        <AntDesign 
                        //style={styles.image}
                        onPress = {()=> uploadDocument()}
                        name={"pdffile1"}
                        size={35}
                        color={defaultStyles.colors.medium}
                        style={styles.icon}         
                        />
                    }

                

                <View style={styles.containerYoutubeLink}>      
                    {/* <MaterialCommunityIcons
                    name={"youtube"}
                    size={30}
                    color={colors.medium}
                    style={styles.iconYoutube}
                    /> */}
                    <TextInput style={styles.inputYoutube} 
                    onChangeText={text => setVideoNumber(text)}
                    value = {videoNumber}
                    placeholder={"Pega link de Youtube y da clic en listo"}
                    //onChange     = {Keyboard.dismiss}
                    >
                    </TextInput>
                          
                      { videoNumber.trim() === '' ?
                      <AntDesign
                      onPress = { () => onChangeText()}
                      name={"checkcircleo"}
                      size={35}
                      color={colors.medium}
                      style={styles.iconPlay}
                      >
                      </AntDesign>
                      :
                      videoNumber.length >= 12 ?
                      <AntDesign
                      onPress = { () => onChangeText()}
                      name={"checkcircleo"}
                      size={35}
                      color={colors.medium}
                      style={styles.iconPlay}
                      > 
                    <Text> * Da clic en listo  </Text>  
                      </AntDesign> 
                      : 
                      <AntDesign
                      onPress = { () => onChangeText()}
                      name={"checkcircle"}
                      size={35}
                      color={colors.fuente}
                      style={styles.iconPlay}
                      >
                      <Text> * Listo !! Video localizado.  </Text>  
                      </AntDesign>
                      }

                  </View>

                { titleBoxText.trim() === '' ?
                <MaterialCommunityIcons
                //onPress = {()=> uploadComment()}
                name={"emoticon-happy-outline"}
                size={45}
                color={defaultStyles.colors.medium}
                style={styles.icon}
                >
                <Text> Fill in both blanks (Title & Description) </Text>  
                </MaterialCommunityIcons>
                :
                 descriptionBoxText.trim() === '' ?
                <MaterialCommunityIcons
                //onPress = {()=> uploadComment()}
                name={"emoticon-happy-outline"}
                size={45}
                color={defaultStyles.colors.medium}
                style={styles.icon}
                >  
                 <Text> Fill in both blanks (Title & Description) </Text>  
                </MaterialCommunityIcons> 
                : 
                <MaterialCommunityIcons
                        onPress = {()=> generateActionId()}
                        name={"upload"}
                        size={45}
                        color={defaultStyles.colors.medium}
                        style={styles.icon}
                    />
                }

                <View style={styles.video} >
                      <VideoVisor videoNumber={videoNumber}/> 
                </View> 
            </View>

            




      </View>
      
      <View style={styles.detailsContainer}>
            <Image
                    style={styles.image}
                    preview={{ uri: webUrl }}
                    tint="light"
                    uri= {webUrl}
                />
            <View style={styles.treeFollowersIconsContainer} >
                {/* <View  >
                    <Text style={styles.tree} numberOfLines={1} >
                      <Entypo name={"tree"}
                                  color={colors.medium} 
                                  size={28} 
                                 // onPress={onPressComment}
                          />                
                      </Text> 
                     <Text style={styles.numbersActionsFollowers} > 1,000 </Text>
                 </View>    
                 <View style={styles.treeFollowersIconsContainer} >
                    <Text style={styles.textFollowers} > Followers </Text>   
                    <Text style={styles.numbersFollowers} > 1.1 M </Text>
                 </View> */}
                     
            </View>         
      </View>
                    {/* <View style={styles.generals}>
                    <Text style={styles.description}>{listing.seedDescription}</Text>
                    </View> */}
         {/* <View style={styles.video} >
         <VideoVisor videoNumber={videoNumber}/>
         </View> */}

         </ScrollView>

         <FlatList
          getItemLayout={sizeItemLayout}
          data={items}
          keyExtractor={(item) => item.seedId.toString()}
          initialScrollIndex={items.index}
          onEndReachedThreshold={0.5}
          onEndReached={() => getActionsList()}

         // initialScrollIndex={route.params.index}
          
          renderItem={({ item, index}) => (
            // <View onLayout= {object => 
            //         itemHeights[index] = object.nativeEvent.layout.height}>
              <CardSeed
                title={item.seedName}
                subTitle={item.totalSeedLikes} // 
                onPressNumLikes={() => {
                  indexLike = index
                  var pick = items[index].seedId
                  navigation.navigate(routes.LISTING_LIKE_USER_PUBLICATION, {pick}  );
                  console.log("presNumLique", indexLike)
                  }                  
                }
                imageUrl={
                  item.seedPhoto.includes('.mp4') ?
                  seedVideoUri + item.seedPhoto :
                  item.seedPhoto.includes('.mov') ?
                  seedVideoUri + item.seedPhoto :
                  webUrl + item.seedPhoto}
                
                onPress={() => {
                  pickSeedId =  items[index].seedId
                  getDataFromSeedActions()
                  //navigation.navigate(routes.SEED_DETAILS, { pickSeedId }) //item
                  }
                }

                onPressLike={ () => {
                  indexLike = index
                  onPressValidationLikeUser()
                 }
                }
                commentsNum={item.totalSeedComments}
                actionsNum={item.totalActions}
                onPressComment={() => {
                  indexLike = index
                  var pick = items[indexLike].seedId
                  navigation.navigate(routes.COMMENST_PUBLICATIONS, {item, pick})
                  }
                }
                thumbnailUrl={webUrl + item.userId + '_' + item.seedPhoto}
              />
            //  </View>
          )}
        />

         

    </>
    
  );
}

const styles = StyleSheet.create({
  containerYoutubeLink: {
    width: "100%",
    //height: "6%",
    //fontSize: 18,
    //color: colors.black,
    //borderWidth: 1,
    marginTop: "2%",
    marginLeft: "2%",
    //padding: "2%", 
    flexDirection:"row",
    //justifyContent: 'space-evenly',
    backgroundColor: '#00000000', // Le puse este color esperando se vuelva transparente '#00000000',
    //backgroundColor: "red",
    //borderRadius: 30,
  },
  containerTitleDescription:{
    marginTop:"5%",
    width:"100%",
    //height:"10%"
},  
  input: {
    width: "80%",
    fontSize: 18,
    color: colors.black,
    borderWidth: 1,
    marginTop: "2%",
    marginLeft: "2%",
    padding: "2%", 
  },
  inputYoutube: {
    width: "80%",
    fontSize: 18,
    color: colors.black,
    borderWidth: 1,
    marginTop: "2%",
    marginLeft: ".3%",
    padding: "2%", 
    //backgroundColor: "red",
  },
  imagePhoto: {
    width: 200,
    height: 200,
    alignSelf: "center",
    marginBottom: "10%",
    borderRadius: 5,
    marginTop: "5%",
  },
  icon:{
    alignSelf:"center",
    marginTop: "7%",
    width:"100%",
},
iconPlay:{
  alignSelf:"center",
  alignContent: "center",
  marginTop: "1%",
  marginLeft: "1%",
  marginRight: "85%",
},
iconYoutube:{
  zIndex: 2,
  justifyContent: 'center', // Esto hace que las imágenes se centren verticalmente no importando que tanto crezca el texto.
  alignSelf:"center",
  padding: "1%",
  backgroundColor: colors.light,
  marginRight: "5%",
  marginLeft: "-1.5%",
  marginTop: "2%",
},
//----------------------------------------------------
  detailsContainer: {     //Contenedor de primera línea botones
    marginLeft: "3%",
    padding: "2%",
    flexDirection: "row",
    width: "92%",
    height: "25%",
    //backgroundColor: "red",
  },
  generals: {
    marginTop: "2%",
    marginLeft: "4%",
    width: "92%",
    //height: "25%", 
  },
  image: {
    marginTop: "1%",
    marginLeft: "2%",
    width: 182,
    height: 182,
   // borderRadius: 2,

  },
  treeFollowersIconsContainer: {
    marginTop: "1%",
    marginLeft: "5%",
    //flexDirection: "row",
    alignItems: "center",
    alignContent: "center",
    //height: "20%",
    backgroundColor: colors.pistache,
  },
  tree:{
    marginLeft: "10%",
    color: colors.dark,
    marginTop: "2%",
   },
   textFollowers: {
    color: colors.medium,
    fontWeight: "900",
    marginTop: "2%",
    marginLeft: "6%",
   },
   numbersActionsFollowers: {
    color: colors.dark,
    marginTop: "2%",
   },
   numbersFollowers: {
    color: colors.dark,
    marginTop: "-2%",
    marginBottom: "2%",
   },
  description: {
    color: colors.greyDescription,
    //fontWeight: "bold",
    fontSize: 17,
    //marginVertical: 10,
    marginRight: "2%",
    marginLeft: "2%",
    marginTop: "1%",
    textAlign: "justify",
    backgroundColor: "yellow",
  },
  video: {
    width: "90%",
    height: "20%",
    marginTop: "2%",
    marginLeft: "5%",
    backgroundColor: colors.pistache,
  },
  seedTitle:{
    marginTop: "1%",
    width: "100%", 
    alignItems: 'center',
    backgroundColor: colors.chakra0red,
  },
  seedTitle1:{
    marginTop: "1%",
    width: "100%", 
    alignItems: 'center',
    backgroundColor: colors.chakra1nar,
  },
  seedTitle2:{
    marginTop: "1%",
    width: "100%", 
    alignItems: 'center',
    backgroundColor: colors.chakra2ama,
  },
  seedTitle3:{
    marginTop: "1%",
    width: "100%", 
    alignItems: 'center',
    backgroundColor: colors.chakra3ver,
  },
  seedTitle4:{
    marginTop: "1%",
    width: "100%", 
    alignItems: 'center',
    backgroundColor: colors.chakra4azu,
  },
  seedTitle5:{
    marginTop: "1%",
    width: "100%", 
    alignItems: 'center',
    backgroundColor: colors.chakra5vlt,
  },
  seedTitle6:{
    marginTop: "1%",
    width: "100%", 
    alignItems: 'center',
    backgroundColor: colors.chakra6rsa,
    //pink
  },
  seedTitle7:{
    marginTop: "1%",
    width: "100%", 
    alignItems: 'center',
    backgroundColor: colors.chakra7ryo,
  },
  seedTitle8:{
    marginTop: "1%",
    width: "100%", 
    alignItems: 'center',
    backgroundColor: colors.chakra8tur,
  },
  seedTitle9:{
    marginTop: "1%",
    width: "100%", 
    alignItems: 'center',
    backgroundColor: colors.chakra9aur,
  },


  title: {
    color: colors.dark,
    //fontWeight: "bold",
    textAlign: "justify",
    fontSize: 18,
    marginTop: "2%",
    width: "90%",
    fontWeight: "500",
    textAlign: "justify",
  },
  buttonsContainersContainer: {
    //padding: 25,
    width: "100%",
    height: "50%",
    //justifyContent: 'center',
    marginVertical: 10,
    //alignItems: "center",
    //textAlign: "center",
  },
  ContainerButtonEdit: {
    marginTop: "9%",
    height: "15%",
    //width: "15%",
  },
  buttonEdit: {
    marginLeft: "2%",
    backgroundColor: colors.primary,
    //borderRadius: 15,
    justifyContent: "center",
    alignItems: "center",
    padding: 4,
   // width: "100%",
    marginRight: "5%",
    
  },
  textEdit: {
    color: colors.white,
    fontSize: 18,
  },
  buttonsContainer1: {
    paddingLeft: "12%",
    flexDirection: "row",
    width: "100%",
    height: 50,
    marginVertical: 10,
    alignItems: "center",
    alignContent: "center",
  },
  buttonsContainer2: {
    padding: 7,
    flexDirection: "row",
    width: "100%",
    height: 50,
    marginVertical: 10,
    alignItems: "center",
  },
  buttonsContainer3: {
    paddingLeft: "12%",
    padding: 7,
    flexDirection: "row",
    width: "100%",
    height: 50,
    marginVertical: 10,
    alignItems: "center",
  },
  bottomMenu: {
    //paddingLeft: "12%",
    //padding: 7,
    flexDirection: "row",
    alignSelf: "flex-end",
    width: "100%",
    height: "10%",
    //marginVertical: 10,
    //alignItems: "center",
    backgroundColor: colors.fuente,

  },

});

export default ActionScreen;
